"use client";

import Image from "next/image";
import React from "react";
import UserProfile from "./UserProfile";

export default function Header() {
  return (
    <header className="w-full flex items-center justify-between gap-3 px-6 md:px-24 py-4 bg-white border-b border-gray-200">
      <div className="flex items-center gap-3">
        <Image
          src="/assets/coventry-logo.png"
          alt="Coventry Group Logo"
          width={40}
          height={40}
        />
        <span className="text-lg md:text-2xl font-bold text-brand-blue">
          Coventry Group Ltd
        </span>
      </div>
      
      <div className="flex items-center">
        <UserProfile 
          avatarBgColor="bg-red-600"
          avatarTextColor="text-white"
        />
      </div>
    </header>
  );
}
